import SuperFetch from '../../../superFetch';
import { ErrorResponse, Request } from '../../../../types/common/utils';
import {
  AccountUserDetailRequestType,
  AccountUserDetailResponseType,
} from '../../../../views/account/user/detail/common/types/accountUserDetail';
import {
  UserDetailVisitorLogListRequestType,
  UserDetailVisitorLogListResponseType,
} from '../../../../views/account/user/detail/AccountUserDetailDeviceList/types/userDetailVisitorLog';

const AccountUserApiV1 = {
  /**
   * [유저] 유저 상세 유저 정보 요청하기
   */
  getAccountUserDetail: (
    data: Request<AccountUserDetailRequestType>,
  ): Promise<AccountUserDetailResponseType | ErrorResponse> => SuperFetch.post('/account/user/detail/user', data),

  /**
   *  [유저] 유저 상세 정보 중 디바이스 타임라인 리스트 요청하기
   */
  getAccountUserDetailVisitorLogList: (
    data: Request<UserDetailVisitorLogListRequestType>,
  ): Promise<UserDetailVisitorLogListResponseType | ErrorResponse> =>
    SuperFetch.post('/account/user/detail/user/visitorLog/list', data),
};

export default AccountUserApiV1;
